import { render, staticRenderFns } from "./StandingTimber.vue?vue&type=template&id=c4cf38ea&"
import script from "./StandingTimber.vue?vue&type=script&lang=js&"
export * from "./StandingTimber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports